import PropTypes from 'prop-types';
import React, {Component } from 'react';
import { Platform,View, StyleSheet} from 'react-native';
import { JDNativeSystem, JDTouchable, JDLoadingView, JDText, JDDevice } from '@jdreact/jdreact-core-lib'

export default class FlatListFooter extends Component {
    static propTypes = {
        statusData: PropTypes.shape({
            isListFetching: Boolean,  //是否正在加载
            error: Object,            //错误
            hasNext: Boolean          //是否还有数据
        }),
    }
    render() {
        const {isListFetching, error, hasNext} = this.props.data;
        if (!hasNext) {
					return (
							<View
									style={[styles.hd,{marginBottom:JDDevice.getRpx(40)}]}>
								<JDText style={styles.title}>— · 没有更多内容了 · —</JDText>
							</View>
					);
        } else if(isListFetching){
            return (
                <View
                    style={[styles.hd,{paddingBottom:this._isOffsetsafeArea()?10 + 34:10,height:this._isOffsetsafeArea()?38+34 : 38}]}>
                    <JDLoadingView/>
                    <JDText style={styles.title}> 加载中...</JDText>
                </View>
            )
        }else if(error){
            return (
                <JDTouchable onPress={() => {this._reloadRcmData()}}>
                    <View
                        style={[styles.hd,{marginBottom:JDDevice.getRpx(40)}]}>
                        <JDText style={styles.title}>加载失败，点击重新加载</JDText>
                    </View>
                </JDTouchable>
            )
        } else {
            return (
                <View
                    style={[styles.hd,{paddingBottom:this._isOffsetsafeArea()?10 + 34:10,height:this._isOffsetsafeArea()?38+34 : 38}]}>
                    <JDLoadingView/>
                    <JDText style={styles.title}> 加载中...</JDText>
                </View>
            );
        }
    }
    _reloadRcmData = () => {
        if (this.props.reloadRcmData) {
            this.props.reloadRcmData();
        }
    }
    // 是否底部需要偏移34px
    _isOffsetsafeArea = () => {
        let isOffsetsafeArea = false;
        if (Platform.OS === 'ios' && JDNativeSystem.isIPhoneX) {
            isOffsetsafeArea = true;
        } else if (Platform.OS === 'web') {
            let ua = (navigator && navigator.userAgent) || ''
            ua = ua.toLowerCase();
            if (JDDevice.height === 724 && ua.indexOf('jdapp') >= 0) {
                isOffsetsafeArea = true;
            }
        }
        return isOffsetsafeArea;
    };
}
const PX1 = JDDevice.getDpx(1);
const styles = StyleSheet.create({
    hd: {
        paddingTop: 10,
        paddingBottom: (Platform.OS === 'ios' && JDNativeSystem.isIPhoneX ) ? 10 + 34 : 10,
        height: (Platform.OS === 'ios' && JDNativeSystem.isIPhoneX ) ? 38 + 34 : 38,
        backgroundColor: '#fff',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    line: {
        borderBottomColor: '#fff',
        borderBottomWidth: PX1,
        borderStyle: 'solid',
        marginLeft: JDDevice.getRpx(20),
        marginRight: JDDevice.getRpx(20),
        height: PX1,
        marginTop: 9,
    },
    hdCnt: {
        flexDirection: 'row',
        width: 100,
        height: 18,
        backgroundColor: '#f0f2f5',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        left: (JDDevice.width - 106) / 2,
        top: 10,
    },
    title: {
        fontSize: JDDevice.getFontSize(26),
        // lineHeight: JDDevice.getFontSize(40),
        color: '#81838e',
    },
});
